import { GlSprintf, GlSkeletonLoader } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { RESOURCE_TYPES } from '~/groups_projects/constants';
import { numberToMetricPrefix } from '~/lib/utils/number_utils';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import getProjectSecretsCount from '../graphql/get_project_secrets_count.query.graphql';
import getGroupSecretsCount from '../graphql/get_group_secrets_count.query.graphql';
export default {
    name: 'DeleteModalSecretsCount',
    components: {
        GlSprintf,
        GlSkeletonLoader
    },
    props: {
        fullPath: {
            type: String,
            required: true
        },
        resourceType: {
            type: String,
            required: true
        }
    },
    emits: [
        'fetch-error'
    ],
    data () {
        return {
            secretsCount: null
        };
    },
    apollo: {
        secretsCount: {
            query () {
                return this.resourceType === RESOURCE_TYPES.PROJECT ? getProjectSecretsCount : getGroupSecretsCount;
            },
            context: {
                featureCategory: 'secrets_management'
            },
            variables () {
                return {
                    fullPath: this.fullPath
                };
            },
            update (data) {
                return data.secretsCount;
            },
            error (e) {
                this.$emit('fetch-error');
                Sentry.captureException(e);
            }
        }
    },
    computed: {
        isLoading () {
            return this.$apollo.queries.secretsCount.loading;
        }
    },
    methods: {
        numberToMetricPrefix
    }
};
